export default function ConclusionSection() {
  return (
    <section id="conclusion" className="relative py-24 bg-slate-900">
      {/* Background */}
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://public.readdy.ai/ai/img_res/e539a5319b20135aa0118c2bb7f66d9c.jpg"
          alt="金門港口夜景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/90 to-slate-900"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-12">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-slate-800 rounded-md border border-slate-700 mb-6">
            <i className="ri-flag-line text-slate-300 text-sm"></i>
            <span className="text-slate-300 text-sm font-medium tracking-wide">投資結論</span>
          </div>

          <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight mb-6">
            金門已進入
            <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-blue-400">多百萬級人流市場</span>
          </h2>

          <p className="text-lg text-slate-300 leading-relaxed mb-4">
            <strong className="text-white font-black">2025年交通旅運量（海運+空運）已達約399萬人次/年</strong>（人次口徑）。
          </p>
          <p className="text-lg text-slate-300 leading-relaxed">
            依據新碼頭運能提升與翔安機場外溢效應，<strong className="text-white font-black kpi-range">2026年 Upside 情境推估為520萬–680萬人次</strong>，金門已具備承接更大規模旅客的交通基礎。
          </p>
        </div>

        {/* 2025 Actual + 2026 Scenarios */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          <div className="bg-gradient-to-br from-orange-500/20 to-orange-600/20 backdrop-blur-sm rounded-lg p-6 border border-orange-400/30 text-center">
            <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-md mx-auto mb-3">
              <i className="ri-checkbox-circle-line text-white text-xl"></i>
            </div>
            <div className="text-xs text-orange-300 uppercase tracking-wider mb-1">2025 實績</div>
            <div className="text-2xl md:text-3xl font-black text-white mb-1 kpi-range">399萬</div>
            <div className="text-xs text-slate-400">交通旅運量/年</div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20 text-center">
            <div className="w-10 h-10 flex items-center justify-center bg-slate-600 rounded-md mx-auto mb-3">
              <span className="text-white text-sm font-black">Base</span>
            </div>
            <div className="text-xs text-slate-300 uppercase tracking-wider mb-1">2026 Base</div>
            <div className="text-xl md:text-2xl font-black text-white mb-1 kpi-range">420萬–520萬</div>
            <div className="text-xs text-slate-400">未納入翔安</div>
          </div>

          <div className="bg-gradient-to-br from-orange-500/20 to-orange-600/20 backdrop-blur-sm rounded-lg p-6 border border-orange-400/30 text-center">
            <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-md mx-auto mb-3">
              <span className="text-white text-sm font-black">Up</span>
            </div>
            <div className="text-xs text-orange-300 uppercase tracking-wider mb-1">2026 Upside</div>
            <div className="text-xl md:text-2xl font-black text-orange-400 mb-1 kpi-range">520萬–680萬</div>
            <div className="text-xs text-slate-400">納入翔安 +8%–15%</div>
          </div>

          <div className="bg-gradient-to-br from-blue-500/20 to-blue-600/20 backdrop-blur-sm rounded-lg p-6 border border-blue-400/30 text-center">
            <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-md mx-auto mb-3">
              <span className="text-white text-sm font-black">Agg</span>
            </div>
            <div className="text-xs text-blue-300 uppercase tracking-wider mb-1">2026 Aggressive</div>
            <div className="text-lg md:text-xl font-black text-blue-400 mb-1 kpi-range">680萬–800萬+</div>
            <div className="text-xs text-slate-400">政策放量情境</div>
          </div>
        </div>

        {/* Market Readiness */}
        <div className="bg-white/5 backdrop-blur-sm rounded-lg p-8 border border-white/10 mb-12">
          <h3 className="text-2xl font-black text-white mb-6 text-center">市場已具備的條件</h3>
          
          <div className="grid lg:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-md flex-shrink-0">
                <i className="ri-store-line text-white text-xl"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-white mb-2">商圈第一排中小型連鎖餐飲</h4>
                <p className="text-slate-400 text-sm">如鹹酥雞、鐵板燒等高頻消費業態，可透過第一排店面快速驗證市場</p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 flex items-center justify-center bg-blue-500 rounded-md flex-shrink-0">
                <i className="ri-building-line text-white text-xl"></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-white mb-2">獨棟旗艦品牌承接團客</h4>
                <p className="text-slate-400 text-sm">大型品牌可規劃獨棟旗艦店，承接專車動線與團客需求</p>
              </div>
            </div>
          </div>
        </div>

        {/* Final Statement */}
        <div className="bg-gradient-to-br from-orange-500 to-blue-500 rounded-lg p-8 text-white text-center mb-12">
          <h3 className="text-2xl font-black mb-2">金門不是小市場</h3>
          <h3 className="text-2xl font-black mb-4">而是剛被打開的市場</h3>
          <p className="text-white/90 text-sm max-w-2xl mx-auto">
            對具備標準化營運能力的連鎖品牌而言，現階段進場有助於以相對合理成本，取得關鍵位置與長期發展優勢。
          </p>
        </div>

        {/* Data Sources */}
        <div className="text-center">
          <h4 className="text-sm font-bold text-white mb-4">資料來源</h4>
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs text-slate-400">
            <a href="https://www.motcmpb.gov.tw/" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap">交通部航港局</a>
            <span className="text-slate-600 hidden md:inline">|</span>
            <a href="https://www.trip.com/" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap">Trip.com</a>
            <span className="text-slate-600 hidden md:inline">|</span>
            <a href="https://www.rome2rio.com/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors cursor-pointer whitespace-nowrap">Rome2Rio</a>
            <span className="text-slate-600 hidden md:inline">|</span>
            <span className="whitespace-nowrap">金門尚義機場</span>
            <span className="text-slate-600 hidden md:inline">|</span>
            <span className="whitespace-nowrap">福建交通船務</span>
          </div>
        </div>
      </div>

      {/* Footer Copyright */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 mt-16 pt-8 border-t border-slate-700/50">
        <div className="text-center text-slate-500 text-sm">
          © 圭貝國際股份有限公司 版權所有
        </div>
      </div>
    </section>
  );
}
